import React from "react";
import { Grid, Badge } from "@material-ui/core";
import {
    ProductCard,
    CheckFAB,
    CloseFAB,
    LocalMallFAB,
    Backdrop,
    Copyright,
    EditableTable,
    PrettyJSON,
} from "../components";
import { isDev, getPartnerName, getDiscountMenu } from "../helpers";
import { FABandBackdrop } from ".";
import DiscountProductShow from "./DiscountProductShow";
import StripePay from "./StripePay.container";

const CardList = ({ toShowMenu }) => {
    let sortedKeys = Object.keys(toShowMenu).sort((keyA, keyB) =>
        String(toShowMenu[keyA].sub[0].id) <= String(toShowMenu[keyB].sub[0].id)
            ? -1
            : 1
    );
    return sortedKeys.map((name) => {
        return (
            <Grid
                item
                key={name}
                xs={12}
                md={6}
                lg={3}
                container
                justify="center"
            >
                <ProductCard
                    name={name}
                    imgSrc={toShowMenu[name].imgSrc}
                    DE={toShowMenu[name].DE}
                    EN={toShowMenu[name].EN}
                    sub={toShowMenu[name].sub}
                />
            </Grid>
        );
    });
};

export default (props) => {
    if (isDev) console.log("render product show");
    let menu = {};
    if (props.menuPart.first === "discount") {
        menu = getDiscountMenu(props.menu.discount);
    } else {
        menu = props.menu[props.menuPart.first][props.menuPart.second];
    }
    console.log({ menu });
    const showImageMenuForDiscount =
        true &&
        // getPartnerName().toLowerCase() === "taumi" &&
        props.menuPart.first === "discount";
    return (
        <FABandBackdrop>
            {/* <StripePay /> */}
            <Grid container direction="row" alignItems="flex-start" spacing={2}>
                {/* {showImageMenuForDiscount ? (
                    <DiscountProductShow
                        toShowMenu={menu}
                        imgName={`mittag-${props.menuPart.city}.jpeg`}
                    />
                ) : (
                    <CardList toShowMenu={menu} />
                )} */}
                <CardList toShowMenu={menu} />
            </Grid>
        </FABandBackdrop>
    );
};
